import React from 'react';
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';

import Base from './Base';

const AntCheckbox = ({ label, ...props }) => {
  const valueExtractor = ({ target: { checked } }) => checked;

  const renderCheckbox = cProps => (
    <Checkbox {...cProps} checked={cProps.value}>
      {label}
    </Checkbox>
  );

  return (
    <Base
      {...props}
      component={renderCheckbox}
      valueExtractor={valueExtractor}
    />
  );
};

AntCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
};

export default AntCheckbox;
